// extracted by mini-css-extract-plugin
export default {"tile":"scaled-tile-tile-ZdUrVN","header":"scaled-tile-header-hW9Ph2","small":"scaled-tile-small-gTGGjn","body":"scaled-tile-body-_8N2sT","footer":"scaled-tile-footer-qLuHe3"};